import http from ":http";

import { SET_VIDEO, SET_VIDEO_SUGGESTIONS } from ":mutations";
import { FETCH_VIDEO, FETCH_VIDEO_SUGGESTIONS } from ":actions";

const state = {
  video: null,
  suggestions: {
    relatedByTags: [],
    older: []
  }
};

const mutations = {
  [SET_VIDEO](state, { video }) {
    state.video = video;
  },

  [SET_VIDEO_SUGGESTIONS]({ suggestions }, { relatedByTags, older }) {
    if (relatedByTags) {
      suggestions.relatedByTags = relatedByTags;
    }

    if (older) {
      suggestions.older = older;
    }
  }
};

const actions = {
  [FETCH_VIDEO]({ commit }, { id }) {
    return http.get(`/videos/${id}`).then(response => {
      commit(SET_VIDEO, { video: response.data });
      return response;
    });
  },

  // Fixme: This feature should be improved also on backend side
  // (There should be dedicated endpoint that returns suggestions to video)
  [FETCH_VIDEO_SUGGESTIONS]({ commit }, { video }) {
    return Promise.all([
      http.get("/videos", {
        params: {
          query: video.title + " " + video.tags.map(t => t.name).join(" "),
          size: 10
        }
      }),
      http.get("/videos", {
        params: {
          sort: "createdDate,desc",
          to: video.createdDate,
          size: 10
        }
      })
    ]).then(([relatedByTags, older]) =>
      commit(SET_VIDEO_SUGGESTIONS, {
        relatedByTags: relatedByTags.data.content.filter(
          s => s.id !== video.id
        ),
        older: older.data.content.filter(s => s.id !== video.id)
      })
    );
  }
};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters
};
